import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Download, FileSpreadsheet, Upload } from "lucide-react";

const ExcelUploadDialogSection = ({ ctx }) => {
  const {
    downloadTemplate,
    handleExcelUpload,
    setUploadDialogOpen,
    setUploadFile,
    setUploadResult,
    uploadDialogOpen,
    uploadFile,
    uploadResult,
    uploading
  } = ctx;
  return (
    <>
      <Dialog open={uploadDialogOpen} onOpenChange={setUploadDialogOpen}>
        <DialogContent className="max-w-xl">
          <DialogHeader>
            <DialogTitle className="font-heading text-2xl">UPLOAD MATERIAL REQUIREMENTS</DialogTitle>
          </DialogHeader>
          
          <div className="space-y-4 mt-4">
            {/* Instructions */}
            <div className="bg-slate-50 p-4 rounded-sm">
              <h4 className="font-heading font-bold text-sm uppercase tracking-widest text-slate-700 mb-2">File Format</h4>
              <p className="text-sm text-slate-600 mb-3">Upload an Excel (.xlsx, .xls) or CSV file with the following columns:</p>
              <ul className="text-sm text-slate-600 space-y-1 ml-4 list-disc">
                <li><strong>material_name</strong> - Name of material (required)</li>
                <li><strong>unit</strong> - Unit of measurement: MT, Cum, Ltr, etc. (required)</li>
                <li><strong>planned_quantity</strong> - Required quantity (required)</li>
                <li><strong>rate</strong> - Unit rate (optional)</li>
                <li><strong>remarks</strong> - Any notes (optional)</li>
              </ul>
              <button
                type="button"
                onClick={downloadTemplate}
                className="mt-3 text-primary text-sm flex items-center space-x-1 hover:underline"
              >
                <Download className="w-4 h-4" />
                <span>Download Sample Template</span>
              </button>
            </div>

            {/* Upload Form */}
            <form onSubmit={handleExcelUpload} className="space-y-4">
              <div>
                <label className="block text-xs font-medium text-slate-700 mb-2 uppercase tracking-widest">Select File *</label>
                <div className="border-2 border-dashed border-slate-300 rounded-sm p-6 text-center hover:border-primary transition-colors">
                  <input
                    type="file"
                    accept=".xlsx,.xls,.csv"
                    onChange={(e) => setUploadFile(e.target.files[0])}
                    className="hidden"
                    id="excel-upload"
                  />
                  <label htmlFor="excel-upload" className="cursor-pointer">
                    <FileSpreadsheet className="w-12 h-12 mx-auto text-slate-400 mb-2" />
                    {uploadFile ? (
                      <p className="text-sm font-medium text-primary">{uploadFile.name}</p>
                    ) : (
                      <p className="text-sm text-slate-600">Click to select Excel or CSV file</p>
                    )}
                  </label>
                </div>
              </div>

              {/* Upload Result */}
              {uploadResult && (
                <div className={`p-4 rounded-sm ${uploadResult.error ? 'bg-red-50 border border-red-200' : 'bg-green-50 border border-green-200'}`}>
                  {uploadResult.error ? (
                    <p className="text-sm text-error">{uploadResult.error}</p>
                  ) : (
                    <div className="text-sm">
                      <p className="font-medium text-success">{uploadResult.message}</p>
                      {uploadResult.errors && uploadResult.errors.length > 0 && (
                        <div className="mt-2">
                          <p className="text-warning font-medium">Warnings ({uploadResult.total_errors}):</p>
                          <ul className="list-disc ml-4 text-slate-600">
                            {uploadResult.errors.map((err, idx) => (
                              <li key={idx}>{err}</li>
                            ))}
                          </ul>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              )}

              <div className="flex justify-end space-x-3 pt-4">
                <button
                  type="button"
                  onClick={() => {
                    setUploadDialogOpen(false);
                    setUploadFile(null);
                    setUploadResult(null);
                  }}
                  className="btn-outline"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={uploading || !uploadFile}
                  className="btn-primary flex items-center space-x-2"
                >
                  <Upload className="w-4 h-4" />
                  <span>{uploading ? "Uploading..." : "Upload & Import"}</span>
                </button>
              </div>
            </form>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ExcelUploadDialogSection;
